import Vue from 'vue';
import {
    checkCCM19Consent,
    checkOneTrustConsent,
    handleClickOnDisclaimerLink,
    normalizeModelName,
} from '../utils';

Vue.component('model-page-component', {
    props: {
        model: {
            type: String,
        },
        entryId: {
            type: String,
        },
        heroModelProp: {
            type: String,
        },
    },

    computed: {
        toggleSubtitleTooltipActiveClass: function () {
            return this.toggleClassOnPropChange(this.isSubtitleTooltipVisible);
        },
        togglePriceTooltipActiveClass: function () {
            return this.toggleClassOnPropChange(this.isPriceTooltipVisible);
        },
        toggleSubtitleTooltipShowAfterClass: function () {
            return this.isSubtitleTooltipVisible
                ? 'carshowcase__content-tooltip--show-after'
                : '';
        },
    },

    data() {
        return {
            isSubtitleTooltipVisible: false,
            isPriceTooltipVisible: false,
            section: null,
            heroModel: null,
        };
    },

    mounted() {
        window.addEventListener('click', handleClickOnDisclaimerLink);

        this.handlePushToDatalayer();

        window.addEventListener('click', this.handleOnElementOutsideClick);

        setTimeout(() => {
            this.handlePushToDatalayer();
        }, [1000]);

        if (this.heroModelProp) {
            this.heroModel = JSON.parse(this.heroModelProp);
        }

        this.section = {
            priceBlock: this.heroModel?.pricesBlockContent ?? null,
        };
    },

    destroyed() {
        window.removeEventListener('click', this.handleOnElementOutsideClick);
    },

    methods: {
        handlePushToDatalayer() {
            if (!checkCCM19Consent() && !checkOneTrustConsent()) return;

            if (!window.dataLayer) {
                window.dataLayer = window.dataLayer || [];
            }

            window.dataLayer.push(
                {
                    pageType: 'Showroom',
                    model: normalizeModelName(this.model, this.siteHandle),
                },
                {
                    event: 'view_car',
                    car: {
                        name: normalizeModelName(this.model, this.siteHandle),
                        ids: [this.entryId],
                    },
                },
            );
        },

        closePriceTooltip() {
            this.isPriceTooltipVisible = false;
        },

        closeSubtitleTooltip() {
            this.isSubtitleTooltipVisible = false;
        },

        toggleClassOnPropChange(prop) {
            return prop ? 'model-header__toolbar-text--active' : '';
        },

        handleOnElementOutsideClick(event) {
            this.handleTooltipOutsideClick(
                '.model-header__subtitle-wrapper',
                event,
                this.closeSubtitleTooltip,
            );

            this.handleTooltipOutsideClick(
                '.model-header__price-wrapper',
                event,
                this.closePriceTooltip,
            );
        },

        handleTooltipOutsideClick(className, event, callback) {
            const tooltip = document.querySelector(className);
            if (!tooltip) return;

            const isClickInsideTooltip = tooltip.contains(event.target);
            if (!isClickInsideTooltip) {
                callback();
            }
        },

        toggleSubtitleTooltip() {
            this.isSubtitleTooltipVisible = !this.isSubtitleTooltipVisible;

            this.$nextTick(() => {
                const tooltip = this.$el.querySelector(
                    '.model-header__toolbar-subtitle',
                );
                if (!tooltip || window.innerWidth < 768) return;

                const tooltipButton = tooltip.closest(
                    '.model-header__toolbar-wrapper',
                );
                if (!tooltipButton) return;

                const rect = tooltipButton.getBoundingClientRect();
                const tooltipWidth = tooltip.offsetWidth;
                const viewportWidth = window.innerWidth;

                const spaceOnLeft = rect.left;
                const spaceOnRight = viewportWidth - rect.right;

                tooltip.classList.remove(
                    'model-header__toolbar-subtitle--align-left',
                );
                tooltip.classList.remove(
                    'model-header__toolbar-subtitle--align-right',
                );

                if (spaceOnLeft > tooltipWidth && spaceOnRight < tooltipWidth) {
                    tooltip.classList.add(
                        'model-header__toolbar-subtitle--align-left',
                    );
                } else {
                    tooltip.classList.add(
                        'model-header__toolbar-subtitle--align-right',
                    );
                }
            });
        },

        togglePriceTooltip() {
            this.isPriceTooltipVisible = !this.isPriceTooltipVisible;
            this.$nextTick(() => {
                const tooltip = this.$el.querySelector(
                    '.model-header__toolbar-price',
                );
                if (!tooltip || window.innerWidth < 768) return;

                const tooltipButton = tooltip.closest(
                    '.model-header__toolbar-wrapper',
                );
                if (!tooltipButton) return;

                const rect = tooltipButton.getBoundingClientRect();
                const tooltipWidth = tooltip.offsetWidth;
                const viewportWidth = window.innerWidth;

                const spaceOnLeft = rect.left;
                const spaceOnRight = viewportWidth - rect.right;

                tooltip.classList.remove(
                    'model-header__toolbar-price--align-left',
                );
                tooltip.classList.remove(
                    'model-header__toolbar-price--align-right',
                );

                if (spaceOnLeft > tooltipWidth && spaceOnRight < tooltipWidth) {
                    tooltip.classList.add(
                        'model-header__toolbar-price--align-left',
                    );
                } else {
                    tooltip.classList.add(
                        'model-header__toolbar-price--align-right',
                    );
                }
            });
        },
    },
});
